import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { CustomInput, FormGroup, Input, Label } from "reactstrap";
import SikkaError from "./SikkaError";
import Datetime from "react-datetime";
import classNames from "classnames";
import { ReactInputMask } from "react-input-mask";

const SikkaInput = ({
  label,
  customLabel,
  id,
  name,
  value,
  defaultValue,
  errors,
  tag: Tag = Input,
  type = "text",
  options = [],
  maxLength,
  pattern,
  placeholder,
  className = "fs--1",
  customType,
  radioValue,
  parentClassName,
  ...rest
}) => {
  customLabel = customLabel || "";
  if (customType === "datetime") {
    return (
      <FormGroup>
        {label && label.includes("*") ? (
          <Label for={id}>
            {label.slice(0, -1)}
            <span style={{ color: "#e63757", marginLeft: "3px" }}>*</span>
          </Label>
        ) : (
          <Label for={id}>{label}</Label>
        )}
        <Datetime
          id={id}
          dateFormat="DD/MM/YYYY"
          timeFormat={false}
          // defaultValue={user[name]}
          //onChange={setStartDate => handleInputChange({ name: name, value: setStartDate })}
          inputProps={{
            value,
            name,
            placeholder,
          }}
          {...rest}
        />
      </FormGroup>
    );
  }

  if (customType === "phone") {
    return (
      <FormGroup>
        {"Mobile No.*" && "Mobile No.*".includes("*") ? (
          <Label for={"mobileNo"}>
            {"Mobile No.*".slice(0, -1)}
            <span style={{ color: "#e63757", marginLeft: "3px" }}>*</span>
          </Label>
        ) : (
          <Label for={"mobileNo"}>{"Mobile No.*"}</Label>
        )}
        <Input
          type="tel"
          size="sm"
          // innerRef={register({
          //   required: "Mobile is required",
          // })}
          className={classNames("fs--1", {
            "border-danger": errors["mobile"]?.message,
          })}
          mask="(999)-999-9999"
          maskChar=" "
          tag={ReactInputMask}
          {...rest}
        />
        <SikkaError error={errors["mobile"]?.message} className="mt-1" />
      </FormGroup>
      // <FormGroup>
      //   {label && label.includes("*") ? (
      //     <Label for={id}>
      //       {label.slice(0, -1)}
      //       <span style={{ color: "#e63757", marginLeft: "3px" }}>*</span>
      //     </Label>
      //   ) : (
      //     <Label for={id}>{label}</Label>
      //   )}
      //   <Tag
      //     type="tel"
      //     name={name}
      //     id={id}
      //     placeholder={placeholder}
      //     mask="(999)-999-9999"
      //     maskChar=" "
      //     tag={InputMask}
      //     // inputRef={register({ required: true })}
      //     className={classNames(className, { "border-danger": errors[name]?.message })}
      //     {...rest}
      //   />
      //   <SikkaError error={errors[name]?.message} className="mt-1" />
      // </FormGroup>
    );
  }
  if (customType === "radio") {
    return (
      <FormGroup>
        {label && label.includes("*") ? (
          <Label for={id}>
            {label.slice(0, -1)}
            <span style={{ color: "#e63757", marginLeft: "3px" }}>*</span>
          </Label>
        ) : (
          <Label for={id}>{label}</Label>
        )}
        <div>
          {options.map((option, index) => (
            <CustomInput
              name={name}
              id={option.key}
              type={type}
              value={option.value}
              defaultValue={defaultValue}
              className={className}
              //checked={radioValue?.toLowerCase()==option.value?.toLowerCase()}
              key={index}
              label={option.key}
              {...rest}
            />
          ))}
        </div>
      </FormGroup>
    );
  }

  if (type === "checkbox" || type === "switch" || type === "radio") {
    return (
      <FormGroup>
        <Tag
          name={name}
          id={id}
          type={type}
          className={className}
          defaultValue={defaultValue}
          label={
            <Fragment>
              {label}
              <SikkaError
                error={errors[name]?.message}
                className="fs--1 font-weight-normal d-block"
              />
            </Fragment>
          }
          {...rest}
        />
      </FormGroup>
    );
  }
  if (type === "select") {
    return (
      <FormGroup>
        {label && label.includes("*") ? (
          <Label for={id}>
            {label.slice(0, -1)}
            <span style={{ color: "#e63757", marginLeft: "3px" }}>*</span>
          </Label>
        ) : (
          <Label for={id}>{label}</Label>
        )}
        <Tag
          name={name}
          id={id}
          type={type}
          defaultValue={defaultValue}
          className={classNames(className, {
            "border-danger": errors[name]?.message,
          })}
          {...rest}
        >
          {options.map((option, index) => (
            <option value={option.value} key={index}>
              {option.key}
            </option>
          ))}
        </Tag>
        <SikkaError error={errors[name]?.message} className="mt-1" />
      </FormGroup>
    );
  }
  return (
    <FormGroup className={parentClassName}>
      {customLabel ? (
        <Label for={id}>{customLabel}</Label>
      ) : label && label.includes("*") ? (
        <Label for={id}>
          {label.slice(0, -1)}
          <span style={{ color: "#e63757", marginLeft: "3px" }}>*</span>
        </Label>
      ) : (
        <Label for={id}>{label}</Label>
      )}
      <Tag
        name={name}
        id={id}
        value={value}
        defaultValue={defaultValue}
        type={type}
        placeholder={placeholder}
        className={classNames(className, {
          "border-danger": errors[name]?.message,
        })}
        {...rest}
      />
      <SikkaError error={errors[name]?.message} />
    </FormGroup>
  );
};

SikkaInput.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

SikkaInput.defaultProps = { required: false };

export default SikkaInput;
